module.exports = __webpack_public_path__ + "img/zanwufajieqian.b2f0a072.png";